import { put, takeEvery } from 'redux-saga/effects';
import { call } from 'typed-redux-saga';
import { logisticsActionCreators, LogisticsActionKeys, UpdateLoadDepartureDate } from '..';
import { showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import { updateLoadDepartureDate } from '../logisticsApi';

function* updateLoadDepartureDateSaga(action: UpdateLoadDepartureDate) {
  yield put(uiActionCreators.showSpinnerDialog());
  const response = yield* call(updateLoadDepartureDate, action.payload);

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else if (response.value) {
    yield put(logisticsActionCreators.setLoad(response.value));
  }

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchUpdateLoadDepartureDate() {
  yield takeEvery(LogisticsActionKeys.UPDATE_LOAD_DEPARTURE_DATE, updateLoadDepartureDateSaga);
}
